import BaseController from '../baseController'
import { unwrap } from '@/helpers/apiResponse'
import { buildODataQuery } from '@/helpers/odata'

class LearningContentsController {
  urlBase = '/learning-contents'

  async list({ filter, top = 20, skip = 0 } = {}) {
    const baseFilter = "estimatedTimeMinutes gt 0"
    const combinedFilter = filter ? `${baseFilter} and ${filter}` : baseFilter
    const res = await BaseController._get(`${this.urlBase}${buildODataQuery({ filter: combinedFilter, top, skip })}`)
    return unwrap(res)
  }

  async getById(id) {
    const res = await BaseController._get(`${this.urlBase}/${id}`)
    return unwrap(res)
  }

  async create(data) {
    const res = await BaseController._post(this.urlBase, data)
    return unwrap(res)
  }

  async update(id, data) {
    const res = await BaseController._patch(`${this.urlBase}/${id}`, data)
    return unwrap(res)
  }

  async remove(id) {
    const res = await BaseController._delete(`${this.urlBase}/${id}`)
    return unwrap(res)
  }
}

export default new LearningContentsController()
